export default __webpack_public_path__ + "static/media/logo-collapsed.7de29a21.svg";